'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = mergeAddons;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Provede merge addons pro input prvky.
 * @param propsAddons addons předné do komponenty přes props, např. addonsBefore
 * @param customAddons vlastní addons komponenty
 * @param customsAtBegin true, pokud se mají custom přidat před props
 * @return nové addons
 */
function mergeAddons(propsAddons, customAddons) {
    var customsAtBegin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    var newAddons = void 0;
    if (!propsAddons) {
        newAddons = customAddons;
    } else {
        newAddons = [customAddons, propsAddons];
    }
    return newAddons;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvdXRpbHMvbWVyZ2VBZGRvbnMuanN4Il0sIm5hbWVzIjpbIm1lcmdlQWRkb25zIiwicHJvcHNBZGRvbnMiLCJjdXN0b21BZGRvbnMiLCJjdXN0b21zQXRCZWdpbiIsIm5ld0FkZG9ucyJdLCJtYXBwaW5ncyI6Ijs7Ozs7a0JBU3dCQSxXOztBQVR4Qjs7Ozs7O0FBRUE7Ozs7Ozs7QUFPZSxTQUFTQSxXQUFULENBQXFCQyxXQUFyQixFQUFrQ0MsWUFBbEMsRUFBdUU7QUFBQSxRQUF2QkMsY0FBdUIsdUVBQU4sSUFBTTs7QUFDbEYsUUFBSUMsa0JBQUo7QUFDQSxRQUFJLENBQUNILFdBQUwsRUFBa0I7QUFDZEcsb0JBQVlGLFlBQVo7QUFDSCxLQUZELE1BRU87QUFDSEUsb0JBQVksQ0FBQ0YsWUFBRCxFQUFlRCxXQUFmLENBQVo7QUFDSDtBQUNELFdBQU9HLFNBQVA7QUFDSCIsImZpbGUiOiJtZXJnZUFkZG9ucy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbi8qKlxuICogUHJvdmVkZSBtZXJnZSBhZGRvbnMgcHJvIGlucHV0IHBydmt5LlxuICogQHBhcmFtIHByb3BzQWRkb25zIGFkZG9ucyBwxZllZG7DqSBkbyBrb21wb25lbnR5IHDFmWVzIHByb3BzLCBuYXDFmS4gYWRkb25zQmVmb3JlXG4gKiBAcGFyYW0gY3VzdG9tQWRkb25zIHZsYXN0bsOtIGFkZG9ucyBrb21wb25lbnR5XG4gKiBAcGFyYW0gY3VzdG9tc0F0QmVnaW4gdHJ1ZSwgcG9rdWQgc2UgbWFqw60gY3VzdG9tIHDFmWlkYXQgcMWZZWQgcHJvcHNcbiAqIEByZXR1cm4gbm92w6kgYWRkb25zXG4gKi9cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIG1lcmdlQWRkb25zKHByb3BzQWRkb25zLCBjdXN0b21BZGRvbnMsIGN1c3RvbXNBdEJlZ2luID0gdHJ1ZSkge1xuICAgIGxldCBuZXdBZGRvbnM7XG4gICAgaWYgKCFwcm9wc0FkZG9ucykge1xuICAgICAgICBuZXdBZGRvbnMgPSBjdXN0b21BZGRvbnM7XG4gICAgfSBlbHNlIHtcbiAgICAgICAgbmV3QWRkb25zID0gW2N1c3RvbUFkZG9ucywgcHJvcHNBZGRvbnNdXG4gICAgfVxuICAgIHJldHVybiBuZXdBZGRvbnM7XG59XG4iXX0=